import styled from 'styled-components';

import { Table } from 'antd';

export const CollapseItemContent = styled.div`
  width: 100%;
  display: inline-flex;
  gap: 0.5rem;
  background-color: #fbfbfb;
`;
export const TableGroup = styled(Table)`
  width: 100%;
`;

export const ColumnTableGroup = styled(Table.Column)`
  height: 10rem;
  color: #fff;
  line-height: 10rem;
  text-align: center;
  background: #364d79;
`;
